import { render } from "./TabsNav.vue?vue&type=template&id=229ad866&scoped=true"
import script from "./TabsNav.vue?vue&type=script&lang=js"
export * from "./TabsNav.vue?vue&type=script&lang=js"

import "./TabsNav.vue?vue&type=style&index=0&id=229ad866&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229ad866"]])

export default __exports__